// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KcXSP","footer":"styles_footer__1rYZ4","passCodeTooltip":"styles_passCodeTooltip__3-WLG"};